"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _DatePicker = _interopRequireDefault(require("./DatePicker"));
var _TimePicker = _interopRequireDefault(require("./TimePicker"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DateTimePicker extends _react.Component {
  static defaultProps = {
    useIcons: true,
    timeStep: 30,
    disablePast: true,
    overrideInitialMonthWithSelected: true,
    iconPosition: 'right'
  };
  constructor(props) {
    super(props);
    const {
      id,
      selectedDate,
      selectedTime,
      tooltipType,
      tooltipMessage,
      tooltipPosition,
      updateTooltipPositionOnMove,
      onTooltipHidden
    } = props;
    if (!id) {
      throw new Error(`The prop 'id' is required to make DateTimePicker accessible for users using assistive technologies such as screen readers. Check the render method of DateTimePicker.`);
    }
    if (tooltipType || tooltipMessage || tooltipPosition || updateTooltipPositionOnMove || onTooltipHidden) {
      throw new Error('Tooltip support inside of DateTimePicker was removed in v6.0.0. Use dateNode and timeNode getters in a parent component to add tooltips manually as necessary.');
    }
    this.state = {
      selectedDate,
      selectedTime
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onChange
    } = this.props;
    const {
      selectedDate,
      selectedTime
    } = this.state;
    const {
      selectedDate: prevSelectedDate,
      selectedTime: prevSelectedTime
    } = prevState;
    if ((selectedDate !== prevSelectedDate || selectedTime !== prevSelectedTime) && onChange) {
      onChange({
        selectedDate,
        selectedTime
      });
    }
  }
  _onDateChange = selectedDate => {
    this.setState({
      selectedDate
    });
  };
  _onTimeChange = selectedTime => {
    this.setState({
      selectedTime
    });
  };

  /**
   * Getter for the date picker input DOM element.
   *
   * @public
   * @returns {Element} - The input element.
   */
  get dateNode() {
    return this._datePicker.node;
  }

  /**
   * Getter for the time picker select DOM element.
   *
   * @public
   * @returns {Element} - The select element.
   */
  get timeNode() {
    return this._timePicker.node;
  }
  render() {
    const {
      className,
      id,
      useIcons,
      iconPosition,
      dateLabel,
      dateDisplayFormat,
      timeDisplayFormat,
      datePlaceholder,
      timeLabel,
      timePlaceholder,
      dateName,
      timeName,
      timeStep,
      calendarClassName,
      overrideInitialMonthWithSelected,
      disablePast,
      disableDateBefore,
      disableDateAfter,
      disableTimeBefore,
      disableTimeAfter,
      useTetherShim,
      disabled
    } = this.props;
    const {
      selectedDate,
      selectedTime
    } = this.state;
    const classes = (0, _classnames.default)('DateTimePicker', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      ref: node => {
        this._datePicker = node;
      },
      id: id,
      name: dateName,
      displayFormat: dateDisplayFormat,
      calendarClassName: calendarClassName,
      useIcon: useIcons,
      iconPosition: iconPosition,
      disabled: disabled,
      label: dateLabel,
      placeholder: datePlaceholder,
      selectedDate: selectedDate,
      overrideInitialMonthWithSelected: overrideInitialMonthWithSelected,
      onChange: this._onDateChange,
      disablePast: disablePast,
      disableBefore: disableDateBefore,
      disableAfter: disableDateAfter,
      useTetherShim: useTetherShim
    }), /*#__PURE__*/_react.default.createElement(_TimePicker.default, {
      ref: node => {
        this._timePicker = node;
      },
      key: `${selectedTime}-${disableTimeBefore}`,
      name: timeName,
      useIcon: useIcons,
      displayFormat: timeDisplayFormat,
      iconPosition: iconPosition,
      disabled: disabled,
      label: timeLabel,
      placeholder: timePlaceholder,
      selectedTime: selectedTime,
      step: timeStep,
      disableBefore: disableTimeBefore,
      disableAfter: disableTimeAfter,
      onChange: this._onTimeChange
    }));
  }
}
exports.default = DateTimePicker;